import {
  computeCreditScore,
  creditScoreBand,
  ICreditScoreConfig,
  ICreditScoreStats,
} from "shared";

import { Badge } from "../../../../../common/Atoms/Badge";
import { FormLabel } from "../../../../../common/Atoms/FormLabel";
import { Paragraph } from "../../../../../common/Atoms/Typography/Paragraph";

const examples: { name: string; stats: ICreditScoreStats }[] = [
  {
    name: `Pays 5 days early, nothing outstanding`,
    stats: {
      weightedAvgDaysLate: -5,
      oldestDaysOverdue: 0,
      overdueHome: 0,
      outstandingHome: 0,
    },
  },
  {
    name: `Pays 15 days late on average, $200 of $1,000 overdue by 10 days`,
    stats: {
      weightedAvgDaysLate: 15,
      oldestDaysOverdue: 10,
      overdueHome: 200,
      outstandingHome: 1000,
    },
  },
  {
    name: `Pays 45 days late on average, everything overdue by 120 days`,
    stats: {
      weightedAvgDaysLate: 45,
      oldestDaysOverdue: 120,
      overdueHome: 1000,
      outstandingHome: 1000,
    },
  },
];

interface CreditScoreExamplesProps {
  config: ICreditScoreConfig;
}

/** Scores a few fixed sample contacts with the unsaved config so the effect of a change is visible before saving */
export function CreditScoreExamples({ config }: CreditScoreExamplesProps) {
  return (
    <div>
      <FormLabel>{ `Example contacts with these settings` }</FormLabel>
      <div className={ `mt-2 space-y-2` }>
        { examples.map(example => {
          const score = computeCreditScore(example.stats, config);

          return (
            <div
              key={ example.name }
              className={ `flex items-center justify-between gap-3 rounded-md bg-gray-50 ring-1 ring-gray-200 px-3 py-2` }
            >
              <Paragraph variant={ `secondary` }>{ example.name }</Paragraph>
              <div className={ `flex items-center gap-2 shrink-0` }>
                <span className={ `text-sm font-semibold text-gray-900` }>{ score ?? `No data` }</span>
                <Badge message={ creditScoreBand(score, config) ?? `` } />
              </div>
            </div>
          );
        }) }
      </div>
    </div>
  );
}
